var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuote = function SvgIconQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    fill: "none",
    viewBox: "0 0 20 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillRule: "evenodd",
    d: "M9.72 10.92H0V0h20v30H9.72z",
    clipRule: "evenodd"
  })));
};
export default SvgIconQuote;